import { getTimezone } from "countries-and-timezones";
import { getFormattedTimezone } from "@helpers/dates";

const myTimezone = getTimezone(
  Intl.DateTimeFormat().resolvedOptions().timeZone,
);

export const isDaylightSavingTime = () => {
  const now = new Date();
  const jan = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
  const jul = new Date(now.getFullYear(), 6, 1).getTimezoneOffset();

  return now.getTimezoneOffset() < Math.max(jan, jul);
};

export const getScheduledTimezone = () => {
  return getFormattedTimezone({
    timeZoneName: myTimezone?.name,
    offsetStr: isDaylightSavingTime()
      ? myTimezone?.dstOffsetStr
      : myTimezone?.utcOffsetStr,
  });
};
